"use client";

import styles from "./ResetPasswordPageHeader.module.scss";

import { WEBSITE_URL } from "@/constants";
import { withLocale } from "@/helpers";
import { useTranslations, useLocale } from "@/i18n";
import { Flex } from "@vetty/ui";
import { Link } from "react-router-dom";

/**
 * ResetPasswordPageHeader Component
 *
 * Navigation header for reset password page with logo and menu links.
 * Provides branding and navigation options for reset password flow.
 */
export const ResetPasswordPageHeader = () => {
  const t = useTranslations("resetPassword.header");
  const locale = useLocale();

  return (
    <Flex align={"center"} justify={"space-between"} className={styles["comp"]}>
      <a href={`${WEBSITE_URL}/${locale}`} className={styles["comp__logo-link"]}>
        <img
          className={styles["comp__logo"]}
          src="/assets/logo-dark.svg"
          alt="Vetty"
        />
      </a>

      <Flex align={"center"} gap={36} className={styles["comp__menu"]}>
        <a
          href={`${WEBSITE_URL}/${locale}/university#contact-sales`}
          className={styles["comp__menu__item"]}
        >
          {t("contactSales")}
        </a>

        <Link
          to={withLocale(locale, "/login")}
          className={styles["comp__menu__item"]}
        >
          {t("logIn")}
        </Link>
      </Flex>
    </Flex>
  );
};
